// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__BIzAl","loading_spinne":"styles_loading_spinne__6WnL+","spin":"styles_spin__zws4W"};